import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { getLoaders } from '../../selectors';
import { updateSurveys } from '../../actions';
import { linkWithParams } from 'routes';
import ASQSimpleSurveysTable from '../../components/asqs/ASQSimpleSurveysTable';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    isLoading: getLoaders(state, ['SURVEYS_FILTER', 'SURVEYS']),
    isFetching: state.surveys.isFetching,
    location: state.router.location,
    meta: state.meta.surveys,
    playerId: state.accountPlayer.player.id,
    surveys: state.accountPlayer.player.last10Asqs,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    onLoadMore: () => {

    },

    onASQLink: (playerId, surveyId, from ) => {
      const path = {
        pathname: linkWithParams('player', { player_id: playerId, id: surveyId }),
        state: from,
      };
      dispatch(push(path));
    },
    onSortChange: (sort, order) => {
      dispatch(updateSurveys({sort, order, init: true}, {source: 'init'}))
    },
  }
}

const ASQSimpleSurveysContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ASQSimpleSurveysTable)

export default ASQSimpleSurveysContainer;
